import React, { useEffect, useState } from 'react';
import { AlarmClock } from 'lucide-react';
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60); // 24 hours in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-orange text-white py-3 px-4 text-center text-sm md:text-base font-medium relative z-50" data-id="element-38">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-39">
        <div className="flex items-center gap-2" data-id="element-40">
          <span className="font-bold uppercase tracking-wider" data-id="element-41">
            Oferta de Lanzamiento
          </span>
          <span className="hidden md:inline" data-id="element-42">—</span>
        </div>
        <p data-id="element-43">
          80% de descuento disponible solo por hoy o hasta agotar los 100 cupos
          promocionales.
        </p>
        <div className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full font-mono font-bold" data-id="element-44">
          <AlarmClock size={16} data-id="element-45" />
          <span data-id="element-46">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
      </div>
    </div>;
}